import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDollarSign, FiTrendingUp, FiTrendingDown, FiActivity, FiBarChart3, FiZap } = FiIcons;

const StatCards = ({ currentPrice, priceData, newsData, sentimentAnalysis }) => {
  const latestData = priceData[priceData.length - 1];
  const previousData = priceData[priceData.length - 2];
  
  const dailyChange = latestData && previousData ? 
    ((latestData.price - previousData.price) / previousData.price) * 100 : 0;
  
  const weeklyChange = priceData.length >= 7 ? 
    ((latestData.price - priceData[priceData.length - 7].price) / priceData[priceData.length - 7].price) * 100 : 0;
  
  const recentNews = newsData.filter(news => {
    const newsDate = new Date(news.date);
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - 7);
    return newsDate >= cutoff;
  });

  const cards = [
    {
      title: 'Current Price',
      value: `$${currentPrice}`,
      change: `${dailyChange >= 0 ? '+' : ''}${dailyChange.toFixed(2)}%`,
      changeColor: dailyChange >= 0 ? 'text-green-600' : 'text-red-600',
      icon: FiDollarSign,
      bgColor: 'bg-blue-50',
      iconColor: 'text-blue-600'
    },
    {
      title: 'Weekly Change',
      value: `${weeklyChange >= 0 ? '+' : ''}${weeklyChange.toFixed(2)}%`,
      change: '7 days',
      changeColor: weeklyChange >= 0 ? 'text-green-600' : 'text-red-600',
      icon: weeklyChange >= 0 ? FiTrendingUp : FiTrendingDown,
      bgColor: weeklyChange >= 0 ? 'bg-green-50' : 'bg-red-50',
      iconColor: weeklyChange >= 0 ? 'text-green-600' : 'text-red-600'
    },
    {
      title: 'News Impact',
      value: `${(sentimentAnalysis.averageImpact * 100).toFixed(1)}%`,
      change: `${recentNews.length} recent`,
      changeColor: 'text-gray-600',
      icon: FiActivity,
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600'
    },
    {
      title: 'Sentiment Score',
      value: `${sentimentAnalysis.counts.positive}/${sentimentAnalysis.counts.negative}`,
      change: 'Pos/Neg',
      changeColor: 'text-gray-600',
      icon: FiBarChart3,
      bgColor: 'bg-yellow-50',
      iconColor: 'text-yellow-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {cards.map((card, index) => (
        <motion.div
          key={card.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-200"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">{card.title}</p>
              <p className="text-2xl font-bold text-gray-900 mt-1">{card.value}</p>
              <p className={`text-sm mt-1 ${card.changeColor}`}>{card.change}</p>
            </div>
            <div className={`p-3 rounded-full ${card.bgColor}`}>
              <SafeIcon icon={card.icon} className={`w-6 h-6 ${card.iconColor}`} />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default StatCards;